import { render } from "./PageElement.vue?vue&type=template&id=b06a339c"
import script from "./PageElement.vue?vue&type=script&lang=js"
export * from "./PageElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__